import { Box, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import dayjs from 'dayjs';

export function buildColumns({
  userId,
  transferTypeLabels,
  onEdit,
  onConfirm,
  onDeny,
  onPreviewImages,
}) {
  return [
    {
      field: 'actions',
      headerName: '動作',
      width: 250,
      renderCell: (params) => {
        const isMine = Number(params.row.receiver) === userId;
        const isPending = params.row.status === 'pending';

        return (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => onEdit(params.row)}
            >
              編輯
            </Button>

            {isMine && isPending && (
              <>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => onConfirm(params.row)}
                >
                  確認
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => onDeny(params.row)}
                >
                  拒絕
                </Button>
              </>
            )}
          </Box>
        );
      }
    },

    {
      field: 'transfer_type',
      headerName: '轉移原因',
      width: 140,
      renderCell: (params) => transferTypeLabels[params.value] || params.value,
    },
    { field: 'supplier', headerName: '供應商', width: 180 },
    { field: 'from_site', headerName: '由地盤', width: 150 },
    { field: 'to_site', headerName: '到地盤', width: 150 },
    {
      field: 'product_name',
      headerName: '貨物',
      width: 160,
      renderCell: (params) => `${params.row.product_catalog_name}, ${params.row.product_name}`
    },
    { field: 'amount', headerName: '數量', width: 100 },

    {
      field: 'status',
      headerName: '狀態',
      width: 110,
      renderCell: (params) => {
        const map = { pending: '待確認', completed: '已完成', denied: '已拒絕' };
        return map[params.value] || params.value;
      },
    },

    {
      field: 'expected_date',
      headerName: '點貨/轉貨/預計到貨/消耗日期',
      width: 220,
      renderCell: (params) =>
        params.value.slice(0, 10),
    },

    { field: 'pair_up_code', headerName: 'Pair up code', width: 120 },
    { field: 'remark', headerName: '備註', width: 150 },

    {
      field: 'images',
      headerName: '圖片',
      width: 130,
      renderCell: (params) =>
        params.row.attachment_count ? (
          <Button
            size="small"
            variant="outlined"
            onClick={() => onPreviewImages(params.row.id)}
          >
            查看圖片
          </Button>
        ) : null,
    },

    { field: 'updated_by_name', headerName: '負責人', width: 180 },
    { field: 'receiver_name', headerName: '指派對象', width: 160 },
    { field: 'created_at', headerName: '建立時間', width: 180 },
  ];
}

export function TransfersTable({
  rows,
  rowCount,
  loading,
  paginationModel,
  setPaginationModel,
  sortModel,
  setSortModel,
  columns,
}) {
  return (
    <Box sx={{ p: 1 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationMode="server"
        sortingMode="server"
        loading={loading}
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        sortModel={sortModel}
        onSortModelChange={(model) => {
          setSortModel(model);
          setPaginationModel((prev) => ({ ...prev, page: 0 }));
        }}
        getRowClassName={(params) => {
          const isCreator = Number(params.row.updated_by) === Number(localStorage.getItem('user_id'));
          const isUnread = params.row.creator_read_status === 0;

          if (isCreator && isUnread) {
            if (params.row.status === 'completed') return 'row-confirmed-unread';
            if (params.row.status === 'denied') return 'row-denied-unread';
          }
          return '';
        }}
        disableRowSelectionOnClick
        getRowHeight={() => 'auto'}
        disableColumnMenu={true}
      />
    </Box>
  );
}
